import axios from 'axios';
import { SessionStore } from '../../types/store/SessionStore';
import { newAbortSignal } from '../../utils';
import { ProjectFile } from '../../types/model/file';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const getStageFiles = async (stageId: number): Promise<ProjectFile[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = `${BASE_URL}/stage/${stageId}`;

  const response = await axios.get<ProjectFile[]>(finalURL, {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': session?.accessToken,
    },
    timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      typeof AbortSignal.timeout !== 'undefined'
        ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
        : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  });

  return response.data;
};